import React, { useMemo } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * /class-schedules/:classId/edit → /classes/:classId/edit
 *
 * The Class Schedule template editor used to be a distinct, simplified UI.
 * The app-wide spec now mandates a SINGLE shared ClassForm for Create + Edit
 * (Pages/Classes/ClassForm) rendered by Pages/Classes/Edit (mode="edit").
 * This route stays for backwards compatibility with existing links; it just
 * hands off to the canonical edit page and forwards `return_url` verbatim so
 * Cancel / post-save behaviour is unchanged.
 */
const Index: React.FC = () => {
  const { classId = "" } = useParams<{ classId: string }>();
  const location = useLocation();

  const target = useMemo(() => {
    const qs = location.search || "";
    return `/classes/${classId}/edit${qs}`;
  }, [classId, location.search]);

  return <Navigate to={target} replace />;
};

export default Index;
